import { z } from 'zod';
import {
  ApplicationStatus,
  ChildInfoSchema,
  EnrollmentProgressSchema,
  GradeLevel,
  MedicalRecordSchema,
  SchoolDivision,
} from '@triedge/admissions-domain';

export const PortalStudentProfileSchema = z.object({
  id: z.string(),
  familyId: z.string().nullable().optional(),
  applicationId: z.string().nullable().optional(),
  studentId: z.string().nullable().optional(),
  childInfo: ChildInfoSchema,
  gradeApplyingFor: GradeLevel,
  schoolDivision: SchoolDivision,
  status: ApplicationStatus,
  enrollmentProgress: EnrollmentProgressSchema.nullable().optional(),
  medical: MedicalRecordSchema.nullable().optional(),
});
export type PortalStudentProfile = z.infer<typeof PortalStudentProfileSchema>;
